// Persistent player session. Stored in localStorage so a player keeps their
// identity across reloads, phone locks, and brief disconnects — the server uses
// playerId to re-attach them to their existing score instead of creating a new
// player on every reconnect.

export interface PlayerSession {
  code: string;
  nickname: string;
  playerId?: string;
}

const KEY = 'beernerd.player';

export function setPlayerSession(s: PlayerSession) {
  localStorage.setItem(KEY, JSON.stringify(s));
}

export function getPlayerSession(): PlayerSession | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PlayerSession;
  } catch {
    return null;
  }
}

/** Merge fields into the stored session (e.g. the playerId from `welcome`). */
export function updatePlayerSession(patch: Partial<PlayerSession>) {
  const cur = getPlayerSession();
  if (!cur) return;
  setPlayerSession({ ...cur, ...patch });
}

export function clearPlayerSession() {
  localStorage.removeItem(KEY);
}
